import React, { useEffect, useState } from 'react'

// third party
import { Link } from 'react-router-dom'
import Pagination from "react-js-pagination";
import { useNavigate, useParams } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
// utils
import { successMessage, errorMessage } from "../utils/toastMessage"
import { paginate } from '../utils/paginate'
//components
import Overlay from "../component/overlay/overlay"
import PageUrlGuid from '../component/pageUrlGuid';
import Footer from '../component/footer';
import Header from '../component/header';
import Seperator from '../component/seperator';
//redux
import { changeState } from '../redux/loading';
//services
import { product } from '../service/productService'



const BuyProduct = () => {
    //=========================================================== use hooks 
    const [getProduct, setProduct] = useState({})
    const [getProductAmount, setProductAmount] = useState(1)
    const address = useParams().address
    const dispatch = useDispatch()
    console.log(1);
    //=========================================================== backend function
    const handleGetProduct = async () => {
        dispatch(changeState(true))
        try {
            const { status, data } = await product(address);
            if (status === 200) {
                setProduct(data.data)
                dispatch(changeState(false))
            }

        } catch (ex) {
            errorMessage("مشکلی از سمت سرور پیش آمده")
            dispatch(changeState(false))
        }

    }
    //=========================================================== frontend operations
    //=========================================================== frontend function
    const handleProductAmount = (amount) => {
        if (amount == -1 && getProductAmount == 1) {

        }
        else {
            setProductAmount(getProductAmount + amount)
        }
    }
    //=========================================================== use effect
    useEffect(() => {
        handleGetProduct()
    }, [])
    return (
        <>
            <Header />
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <Link to={"/products"}>
                    محصولات
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    {getProduct.name}
                </h1>
            </PageUrlGuid>
            <div className='product-page'>
                <img src={getProduct.imagePath} alt={getProduct.name} />
                <div className='informations'>
                    <div className='info'>

                        <h2 className='title'>{getProduct.name}</h2>
                        <h3 className='des'>{getProduct.description}</h3>
                        <h3 className='price'>
                            {getProduct.price} تومان
                        </h3>
                    </div>
                    <div className='buy'>
                        <div className='counter'>
                            <i className='fa fa-plus' onClick={() => handleProductAmount(1)}></i>
                            <input className="quantity" min="1" name="quantity" value={getProductAmount} type="number" />
                            <i className='fa fa-minus' onClick={() => handleProductAmount(-1)}></i>
                        </div>
                        <span>{getProduct.price * getProductAmount} تومان</span>
                        <a href="">خرید این محصول</a>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}


export default BuyProduct
